import { eur, frDate } from "@/lib/api";

const BADGE = {
  confirmed: "bg-brass text-ink", approved: "bg-white/10 text-bone",
  requested: "bg-brass/20 text-brass", declined: "bg-white/5 text-muted-foreground",
  cancelled: "bg-white/5 text-muted-foreground",
};

export default function BookingCard({ b, giteName, label, payLabel, depositLabel, depositNote, onDecide, onDeposit,
                                      onCancel, onOffline, onDelete, onEdit, onDocs,
                                      onDepositLink, onDepositRelease }) {
  return (
    <div className="border border-white/10 bg-panel p-4" data-testid={`booking-card-${b.id}`}>
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="truncate font-semibold text-bone">{b.name}</p>
          <p className="truncate text-xs text-muted-foreground">{giteName}</p>
        </div>
        <span className={`shrink-0 px-2.5 py-1 text-[10px] font-semibold uppercase ${BADGE[b.status] || ""}`}>
          {label}
        </span>
      </div>

      <div className="mt-3 flex items-baseline justify-between gap-3">
        <p className="text-sm text-bone">{frDate(b.start_date)} → {frDate(b.end_date)}</p>
        <p className="shrink-0 font-display text-lg text-brass">{eur(b.total)}</p>
      </div>
      <p className="mt-1 text-[11px] text-muted-foreground">
        {b.nights} nuit{b.nights > 1 ? "s" : ""} · {b.guests} pers.
        {b.adults != null ? ` dont ${b.adults} majeur${b.adults > 1 ? "s" : ""}` : ""} · {payLabel}
      </p>
      {depositLabel && (
        <p className="mt-1 text-[11px] text-brass" data-testid={`c-deposit-state-${b.id}`}>{depositLabel}</p>
      )}
      {depositNote && (
        <p className={`mt-1 text-[11px] ${b.deposit_expires_early || b.deposit_status === "expired" ? "text-destructive" : "text-muted-foreground"}`}
          data-testid={`c-deposit-note-${b.id}`}>{depositNote}</p>
      )}
      {(b.email || b.phone) && (
        <p className="mt-2 break-all text-[11px] text-muted-foreground">
          {b.email}{b.phone ? ` · ${b.phone}` : ""}
        </p>
      )}

      <div className="mt-4 flex flex-wrap gap-2">
        {["requested", "approved"].includes(b.status) && (
          <>
            <button onClick={() => onDecide(b.id, "approve")} data-testid={`c-approve-${b.id}`}
              className="border border-brass bg-brass/10 px-3 py-2 text-[11px] font-semibold uppercase text-brass">
              Valider &amp; encaisser
            </button>
            <button onClick={() => onOffline(b.id)} data-testid={`c-offline-${b.id}`}
              className="border border-white/20 px-3 py-2 text-[11px] uppercase text-bone">
              Confirmer (espèces)
            </button>
            <button onClick={() => onDecide(b.id, "decline")} data-testid={`c-decline-${b.id}`}
              className="border border-white/10 px-3 py-2 text-[11px] uppercase text-muted-foreground">
              Refuser
            </button>
          </>
        )}
        {b.status === "confirmed" && b.deposit_status !== "held" && b.deposit_status !== "released" && (
          <button onClick={() => onDepositLink(b.id)} data-testid={`c-deposit-link-${b.id}`}
            className="border border-brass bg-brass/10 px-3 py-2 text-[11px] font-semibold uppercase text-brass">
            Lien caution
          </button>
        )}
        {b.deposit_status === "held" && (
          <>
            <button onClick={() => onDeposit(b.id)} data-testid={`c-deposit-${b.id}`}
              className="border border-brass px-3 py-2 text-[11px] uppercase text-brass">Prélever</button>
            <button onClick={() => onDepositRelease(b.id)} data-testid={`c-deposit-release-${b.id}`}
              className="border border-white/20 px-3 py-2 text-[11px] uppercase text-bone">Libérer</button>
          </>
        )}
        {b.status === "confirmed" && b.deposit_status !== "held" && b.deposit_status !== "released"
          && b.deposit_status !== "expired" && b.stripe_payment_method_id && (
          <button onClick={() => onDeposit(b.id)} data-testid={`c-deposit-fallback-${b.id}`}
            className="border border-white/20 px-3 py-2 text-[11px] uppercase text-brass">Caution</button>
        )}
        <button onClick={() => onDocs(b)} data-testid={`c-docs-${b.id}`}
          className="border border-brass/60 px-3 py-2 text-[11px] uppercase text-brass">Documents</button>
        <button onClick={() => onEdit(b)} data-testid={`c-edit-${b.id}`}
          className="border border-white/20 px-3 py-2 text-[11px] uppercase text-bone">Modifier</button>
        {b.status !== "cancelled" && (
          <button onClick={() => onCancel(b.id)} data-testid={`c-cancel-${b.id}`}
            className="border border-destructive/40 px-3 py-2 text-[11px] uppercase text-destructive">Annuler</button>
        )}
        <button onClick={() => onDelete(b.id, b.name)} data-testid={`c-delete-${b.id}`}
          className="border border-destructive/40 px-3 py-2 text-[11px] uppercase text-destructive">Supprimer</button>
      </div>
    </div>
  );
}
